import * as React from 'react';
import { connect } from 'react-redux';
import { TRAINING_DOMAINS } from '../../base/constants';
import { IState } from '../../store/state';
import * as Selectors from '../selectors';
import { EvaluationActions } from '../slice';
import useUserIdFromRoute from '../useUserIdFromRoute';
import PerformanceContainer from './PerformanceContainer';
import './PerformanceView.scss';
import './TabViews.scss';

export interface IPerformanceViewProps {
  ready: boolean;
  onInit: (userId?: number) => void;
}

export const PerformanceViewFC: React.FC<IPerformanceViewProps> = ({ onInit, ready }) => {
  const userId = useUserIdFromRoute();
  React.useEffect(() => {
    if (ready) {
      return;
    }
    onInit(userId);
  }, [onInit, ready, userId]);
  return (
    <div className="statistics-tab-content performance-view" data-testid="performance-tab">
      {TRAINING_DOMAINS.map((domain) => (
        <PerformanceContainer key={domain} domain={domain} userId={userId} />
      ))}
    </div>
  );
};

const mapStateToProps = (state: IState) => {
  const ready = Selectors.areHighscoresReady(state);
  return {
    ready,
  };
};

export const mapDispatchToProps = {
  onInit: EvaluationActions.initPerformancePage,
};

const PerformanceView = connect(mapStateToProps, mapDispatchToProps)(PerformanceViewFC);
export default PerformanceView;
